import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BusinessIntelligenceDashboardComponent } from './business-intelligence.dashboard.component';
import { BusinessIntelligenceService }            from './business-intelligence.service';
import { SharedModule }                           from '../shared/shared.module';

@NgModule({
  declarations: [
    BusinessIntelligenceDashboardComponent
  ],
  exports: [
    BusinessIntelligenceDashboardComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    BusinessIntelligenceService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BusinessIntelligenceModule {}
